// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ui9H","select":"styles_select__2hknK"};